import { Button } from '@components/button';
import { classNames } from '@lib/classNames/classNames';
import { memo, useCallback } from 'react';

export const Industry = memo(
  ({
    industry,
    industriesFilter,
    productsFilter,
    onIndustryChange,
  }: {
    industry: string;
    industriesFilter: string[];
    productsFilter: string[];
    onIndustryChange: (newIndustries: string[], url: string) => void;
  }) => {
    const handleClick = useCallback(() => {
      const newSearchParams = new URLSearchParams();

      const newIndustries = industriesFilter.includes(industry)
        ? industriesFilter.filter((value) => value !== industry)
        : [...industriesFilter, industry];

      for (const industry of newIndustries) {
        newSearchParams.append('industries', industry);
      }

      for (const product of productsFilter) {
        newSearchParams.append('products', product);
      }

      const url = `/cases${newSearchParams.size ? `?${newSearchParams}` : ''}`;

      onIndustryChange(newIndustries, url);
    }, [industriesFilter, industry, onIndustryChange, productsFilter]);

    return (
      <Button
        type="button"
        onClick={handleClick}
        className={classNames({
          cls: 'bg-surface-base-secondary cursor-pointer rounded-lg px-4 py-2 text-sm leading-[1.13rem]',
          mods: {
            '!bg-[#62C84D]': industriesFilter?.includes(industry),
          },
        })}
      >
        {industry}
      </Button>
    );
  },
);

Industry.displayName = 'Industry';
